module.exports = __webpack_public_path__ + "static/media/train6.1b0e3867.jpg";